const base = import.meta.env.BASE_URL.replace(/\/$/, '')

export const homePath = `${base}/`
export const lessonPath = (slug: string) => `${base}/lesson/${slug}/`

export function currentLessonSlug() {
  const relative = window.location.pathname.slice(base.length)
  return relative.match(/^\/lesson\/(\d{4}-\d{2}-\d{2})\/?$/)?.[1] ?? null
}
